import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Stack,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";

import PaymentIcon from "@mui/icons-material/Payment";
import LogoutIcon from "@mui/icons-material/Logout";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import HistoryIcon from "@mui/icons-material/History";
import PeopleIcon from "@mui/icons-material/People";

const AdminNavbarLinks = [
  { label: "ゲスト管理", icon: PeopleIcon, to: "/host/guest-manage" },
  { label: "送金URL管理", icon: PaymentIcon, to: "/host/payment-url" },
  { label: "ヒストリ", icon: HistoryIcon, to: "/host/history" },
  { label: "当日受付", icon: PlaylistAddCheckIcon, to: "/host/reception" },
  { label: "ログアウト", icon: LogoutIcon, to: "/host/logout" },
];

const ReceptionistNavbarLinks = [
  { label: "当日受付", icon: PlaylistAddCheckIcon, to: "/host/reception" },
  { label: "ログアウト", icon: LogoutIcon, to: "/host/logout" },
];

const Navbar = () => {
  const [window, setWindow] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const role = useSelector((state) => state.role);

  // メニューの開閉処理
  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  // roleに基づいて表示するリンクを選択
  const NavbarItems =
    role === "admin" ? AdminNavbarLinks : ReceptionistNavbarLinks;

  return (
    <>
      {/* モバイルサイズの時にハンバーガーメニューを表示 */}
      {isMobile ? (
        <>
          <Grid container spacing={1} alignItems="center" flexDirection="row">
            <IconButton
              size="large"
              variant="outlined"
              edge="start"
              aria-label="menu"
              color="inherit"
              onClick={() => toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
          </Grid>

          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={() => toggleDrawer(false)}
          >
            <div style={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "25px 0 0 0",
                }}
              >
                <Typography>Marrynager</Typography>
              </Box>
            </div>

            <List>
              {NavbarItems.map((item, i) => {
                const isActive = location.pathname === item.to; // 現在のページかどうかを確認

                return (
                  <ListItem button key={i} onClick={() => toggleDrawer(false)}>
                    <Link to={item.to} style={{ textDecoration: "none" }}>
                      <ListItemText
                        primary={
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                          >
                            <item.icon />
                            <Typography variant="body1">
                              {item.label}
                            </Typography>
                          </Stack>
                        }
                        className={`navbar__li ${isActive ? "active" : ""}`}
                      />
                    </Link>
                  </ListItem>
                );
              })}
            </List>
          </Drawer>
        </>
      ) : (
        // デスクトップサイズ以上の時には元のメニューを表示
        <nav
          className="navbar-menu"
          style={{ width: window === false ? 250 : 60 }}
        >
          <div className="navbar-logo">Marrynager</div>
          <ul className="navbar__list">
            {NavbarItems.map((item, i) => {
              const isActive = location.pathname === item.to;

              return (
                <div className="navbar__li-box" key={i}>
                  <Link to={item.to}>
                    <li
                      className={`navbar__li ${isActive ? "active" : ""}`}
                      style={{
                        display: window === false ? "inline-block" : "none",
                      }}
                    >
                      <div className="nabvar-item-container">
                        <div className="navbar-item-icon">
                          {React.createElement(item.icon)}
                        </div>
                        {item.label}
                      </div>
                    </li>
                  </Link>
                </div>
              );
            })}
          </ul>
        </nav>
      )}
    </>
  );
};

export default Navbar;
